import { measuredCookieReduxKey } from './constants';
import { MeasuredCookie } from './MeasuredCookie';
import { createSelector } from 'reselect';
function getSizeForCookie(state, cookieType) {
    return state[measuredCookieReduxKey] && state[measuredCookieReduxKey][cookieType];
}
// we use a selector creator to avoid different component instances clobbering
// each others' memoization
export function makeGetPrevLoadDims() {
    return createSelector([
        getSizeForCookie,
        (state, cookieType, cookieDim)=>cookieDim
    ], (serverSize, cookieDim)=>{
        switch(cookieDim){
            case 'both':
                if (Array.isArray(serverSize)) {
                    return {
                        width: serverSize[0],
                        height: serverSize[1]
                    };
                }
                break;
            case 'width':
                if (!Array.isArray(serverSize)) {
                    return {
                        width: serverSize || 0,
                        height: 0
                    };
                }
                break;
            case 'height':
                if (!Array.isArray(serverSize)) {
                    return {
                        height: serverSize || 0,
                        width: 0
                    };
                }
                break;
            default:
                break;
        }
        return {
            width: 0,
            height: 0
        };
    });
}
export function getCookieSize(state, type) {
    return MeasuredCookie.get(type) || getSizeForCookie(state, type);
}
export function hasCookie(state, type) {
    var _state_measuredCookieReduxKey;
    return !!MeasuredCookie.get(type) || !!((_state_measuredCookieReduxKey = state[measuredCookieReduxKey]) === null || _state_measuredCookieReduxKey === void 0 ? void 0 : _state_measuredCookieReduxKey[type]);
}

//# sourceMappingURL=selectors.js.map